<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="dedication">
<h1>Dedication</h1>
<p>How much I love to place my head on her pillow and between her arms. Her warm touch was the last thing I felt before closing my eyes. In her hands, there is peace and reassurance that I desire to surround our world today. She made me see myself and discover my identity. She made me up from her words and her feelings. She drew my way in knowledge. And created the writer I am today. To the lady of my thoughts and the lady of my pens. To my soulmate and my entire life. To my mother.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?2e7c8f4e